import React from 'react'
import AutoTaggingAlert from './auto-tagging-alert'
import AutoTaggingBanner from './auto-tagging-banner'
import styles from './index.module.css'

const isShowBanner = ({ autoTaggedTracksTrial, isTrial, isEmptyChannel }) => {
  return (
    (!autoTaggedTracksTrial && !isTrial && isEmptyChannel) ||
    (isEmptyChannel && autoTaggedTracksTrial)
  )
}

type Props = {
  auto_tagging_tracks_sent: number
  auto_tagging_tracks_limit: number
  autoTaggedTracksTrial: boolean
  videoSrc?: string
  isTrial: boolean
  searchResultsCount: number
  isLoading?: boolean
}

const AutoTagging = (props: Props): React.ReactElement<'div'> => {
  const {
    auto_tagging_tracks_sent,
    autoTaggedTracksTrial,
    isTrial,
    searchResultsCount,
    isLoading,
  } = props
  const isEmptyChannel =
    auto_tagging_tracks_sent === 0 && searchResultsCount === 0 && !isLoading
  const shouldShow = isShowBanner({
    autoTaggedTracksTrial,
    isTrial,
    isEmptyChannel,
  })
  if (!shouldShow) return <div />
  return (
    <div className={styles.autoTagging}>
      <AutoTaggingBanner {...props} />
    </div>
  )
}

export default AutoTagging
